module.exports = __webpack_public_path__ + "img/tooltip.0869db85.svg";